// Whether the feedback dialog is open: the top bar's Feedback button and the
// `F` shortcut open it; App.svelte holds the one dialog. A failure's Send
// feedback (FailureDetails.svelte) opens it with a note started for the user.

class FeedbackUi {
  open = $state(false);
  /** A note to start the dialog with, taken (and cleared) as it opens. */
  draft = $state('');

  show(draft = ''): void {
    this.draft = draft;
    this.open = true;
  }
}

export const feedbackUi = new FeedbackUi();
